// extracted by mini-css-extract-plugin
export var tosLink = "_br-0";